import service from "@/utils/request";

// 区号列表
export const smsAreaCodeListApi = () => {
  return service({
    url: "/api/v1/sms/area_code_list",
    method: "get",
  });
};
